import React from 'react';
import Hero from '../../components/hero/Hero';
// import Trust from '../../components/trust/Trust';
import Featured from '../../components/featured/Featured';
import DescComp from '../../components/desc/DescComp';
import choose from "../../assets/choose.png";
// import works from "../../assets/works.png";

const Homepage = () => {

        const reasonsArr= [
            {
                ques: "Expert Agents: ",
                ans: "Who guide you with unparalleled expertise."
            },
            {
                ques: "Verified Listings: ",
                ans: "Ensuring only the highest quality properties."
            },
            {
                ques: "Personalized Solutions: ",
                ans: "Tailored to meet your unique needs."
            },
            {
                ques: "Market Insights: ",
                ans: "To help you make informed real estate decisions."
            },
        ]
        // const worksArr= [
        //     {
        //         ques: "Search Properties: ",
        //         ans: "for exclusive listing that match your needs."
        //     },
        //     {
        //         ques: "Connect with an Agent: ",
        //         ans: "for expert guidance throughout your journey."
        //     },
        //     {
        //         ques: "Schedule a Viewing: ",
        //         ans: "to explore properties at your convenience."
        //     },
        //     {
        //         ques: "Close the Deal: ",
        //         ans: "with our support every step of the way."
        //     },
        // ]

  return (
    <div>
        <Hero />
        {/* <Trust /> */}
        {/* <SearchFilter /> */}
        <Featured />
        <DescComp title={"Why Choose Us?"} text={"We’re dedicated to delivering exceptional service and unmatched expertise in the real estate market. Our features are designed to provide a seamless and stress-free, and rewarding experience, whether you’re buying, selling, or investing in property."} image={choose} descArr={reasonsArr} descBg={"#080B24"} />
        {/* <DescComp title={"How It Works?"} text={"Navigating the real estate market can be overwhelming, but we simplify the process for you with our step-by-step approach, you can easily find your dream property. Connect with smart agents, and enjoy seamless experience from start to finish. Our dedicated team is here to support you at every stage, ensuring you make informed decision with confidence."} image={works} descArr={worksArr} color={true} /> */}
    </div>
  )
}

export default Homepage